import React from "react";
import "./summaryBox.scss";
import Sticky from "react-stickynode";
import { CalculateStore } from "../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import Formatter from "../../../helpers/formatter";
import { PolicyDurationId } from "../../../helpers/additionalQuestions/policyDuration";
import Loader from "../loader/Loader";
import {
  defaultOneShareAcquisition,
  defaultTuzAccession,
  isClientTuzMember
} from "../../../helpers/client";
import Installments from "./installments";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";
import ExceededProxiesInfo from "../../exceededProxies/exceededProxiesInfo";
import {PolicyStore} from "../../../stores/policyStore";

interface SummaryBoxProps {
  calculateStore?: CalculateStore;
  uiFlagsStore?: UiFlagsStore;
  displayLoader?: boolean;
  exceededProxies?: boolean;
  exceededProxiesForRemoteSale?: boolean;
  policyStore?: PolicyStore;
}

interface State {
  bottomBoundary: number;
}

@inject("calculateStore", "uiFlagsStore", "policyStore")
@observer
export default class SummaryBox extends React.Component<SummaryBoxProps, State> {
  private isMount: boolean | undefined;

  constructor(props: SummaryBoxProps) {
    super(props);
    this.state = { bottomBoundary: 0 };
  }

  componentDidMount() {
    this.isMount = true;

    window.addEventListener("resize", this.getBottomBoundary.bind(this));
    document.addEventListener("scroll", this.getBottomBoundary.bind(this));
  }

  componentWillUnmount() {
    this.isMount = false;

    window.removeEventListener("resize", this.getBottomBoundary.bind(this));
    document.removeEventListener("scroll", this.getBottomBoundary.bind(this));
  }

  render() {
    const isMobile = this.props.uiFlagsStore!.isMobile;

    return (
      <div className={`summary-box-sticky-container ${isMobile ? "is-mobile" : ""}`}>
        <Sticky top={isMobile ? 0 : 130} enabled={!isMobile}
          bottomBoundary={this.state.bottomBoundary}>
          <div
            className={`summary-box-content ${this.props.displayLoader ? "with-loader" : ""}`}>
            <div className="top-part">
              {this.props.displayLoader && <Loader />}
              <div className="header">Twój wybór</div>
              {this.renderTotalAmount()}
              {this.showDiscountMessage()}
              {this.isMoreThanOneInstallments() && <Installments />}
              {this.renderPolicyDuration()}
              {this.renderTuzMemberInfo()}
            </div>
            {(this.props.exceededProxies || this.props.exceededProxiesForRemoteSale) &&
              <ExceededProxiesInfo />}
            <div className="button-wrapper">
              {this.props.children}
            </div>
          </div>
        </Sticky>
      </div>
    );
  }

  private getBottomBoundary() {
    const footerBottom = document.querySelector("tuz-estate-widget")?.shadowRoot?.querySelector(".footer")?.getBoundingClientRect()?.bottom || 0;
    const bottomBoundary = Math.round(footerBottom + window.scrollY);

    if (bottomBoundary !== this.state.bottomBoundary && this.isMount) {
      this.setState({ bottomBoundary });
    }
  }

  private isMoreThanOneInstallments() {
    const response = this.props.calculateStore!.calculationResponse;
    return response?.installments && response!.installments.length > 1;
  }

  private renderTotalAmount() {
    const calculateStore = this.props.calculateStore!;
    const totalAmountFromResponse = calculateStore.calculationResponse?.totalAmount;
    const requireRecalculate = calculateStore.requireRecalculate;

    const totalAmount = totalAmountFromResponse ?
      `${Formatter.decimalPriceFormat(Formatter.convertCentsToNormalNumber(totalAmountFromResponse))} zł` :
      "???";

    return (
      <div className={`total-amount ${requireRecalculate ? "require-recalculate" : ""}`}>
        <span className="label">Razem: </span>
        <span className="value">{totalAmount}</span>
      </div>
    );
  }

  private renderPolicyDuration() {
    const calculateStore = this.props.calculateStore!;
    const policyDuration = calculateStore.additionalQuestions.policyDuration.value;
    let policyDurationToDisplay = "";

    switch (policyDuration) {
      case PolicyDurationId.MONTHS_12:
        policyDurationToDisplay = "1 rok";
        break;
      case PolicyDurationId.MONTHS_36:
        policyDurationToDisplay = "3 lata";
        break;
      default:
        policyDurationToDisplay = "";
    }

    return (
      <div className="policy-duration">
        <span className="label">Okres ubezpieczenia: </span>
        <span className="value">{policyDurationToDisplay}</span>
      </div>
    );
  }

  private renderTuzMemberInfo() {
    const requireRecalculate = this.props.calculateStore!.requireRecalculate;
    const value = isClientTuzMember(this.props.calculateStore!) ? "Tak" : this.getTuzMemberPrice();

    return <div
      className={`tuz-member-info ${requireRecalculate ? "require-recalculate" : ""}`}>
      <span className="label">Członkostwo i udział w TUZ TUW: </span>
      <span className="value">{value}</span>
    </div>;
  }

  private getTuzMemberPrice() {
    const calculateStore = this.props.calculateStore!;

    if (calculateStore.calculationRequestStatus.isDone) {
      const entryFees = this.props.calculateStore!.calculationResponse?.entryFees;
      const sum = (entryFees?.tuzAccession || defaultTuzAccession) + (entryFees?.oneShareAcquisition || defaultOneShareAcquisition);
      return Formatter.decimalPriceFormat(Formatter.convertCentsToNormalNumber(sum)) + " zł";
    }

    return null;
  }

  private showDiscountMessage() {
    if (!this.props.uiFlagsStore!.isDirect && !this.props.policyStore?.isPolicyRenewal) {
      return this.usedDiscounts();
    }
    return null;
  }

  private usedDiscounts() {
    return <div className="discount-message">
      <span>Składka uwzględnia zniżki użyte w sekcji „Zniżki i postanowienia dodatkowe”</span>
    </div>;
  }
}
